module.exports = {"items":{"home":"OMyFu","profile":"Profil","funeral":{"topLevel":"My Funeral","burial":"Bestattung","ceremony":"Abschiedszeremonie","guestlist":"Gästeliste","speeches":"Reden & Ansprachen"},"guardians":{"topLevel":"Guardians","guardians":"Meine Guardians","proteges":"Ich bin Guardian","invitations":"Einladungen"},"contacts":"Kontakte","photos":"Fotos","documents":"Dokumente","pets":"Haustiere","links":"Links","account":"Account","logout":"Logout","languageSwitcher":"DE"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/menu.json
// module id = 25jb
// module chunks = 1